import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'

export class GetSellVehicleConfigFormUseCase extends UseCase {
  constructor({
    config,
    fromSpecsParamsToSearchUrlValueObjectMapper,
    getCurrentUserService,
    sellVehicleConfigFormVOMapper,
    specsFormService
  }) {
    super()
    this._config = config
    this._fromSpecsParamsToSearchUrlValueObjectMapper = fromSpecsParamsToSearchUrlValueObjectMapper
    this._getCurrentUserService = getCurrentUserService
    this._sellVehicleConfigFormVOMapper = sellVehicleConfigFormVOMapper
    this._specsFormService = specsFormService
    this._isMotos = this._config.get('APP_NAME') === this._config.get('APP_NAME_MOTOS')
  }

  @tracer({metric: 'GetSellVehicleConfigFormUseCase#execute'})
  @inlineError
  async execute({withAdditionalCarDataFields = false, withPostalCodeField = false} = {}) {
    if (this._isMotos) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }

    const userEntity = await this._getCurrentUserService.execute()

    const searchUrlVO = this._fromSpecsParamsToSearchUrlValueObjectMapper.map({
      dataSource: 'form',
      nextField: 'makes',
      resourceName: 'vehicle-specs/v1'
    })

    const [, makesSpecsFormVO] = await this._specsFormService.execute({
      searchUrlVO
    })

    const configFormVO = this._sellVehicleConfigFormVOMapper
      .setParams({
        makesSpecsFormVO,
        userEntity,
        withAdditionalCarDataFields,
        withPostalCodeField
      })
      .map()

    return configFormVO.toJSON()
  }
}
